import { transactionHistoryType } from '../../actionTypes';
const initialState = {
  transactionDetails: [],
  filterColumnsData: {},
};

const transactionHistory = (state = initialState, action) => {
  switch (action.type) {
    case transactionHistoryType.TRANSACTION_HISTORY_DATA:
      action.payload || {};
      return {
        ...state,
        transactionDetails: action.payload || {},
      };
    case transactionHistoryType.FILTER_COLUMNS_DATA:
      action.payload || {};
      return {
        ...state,
        filterColumnsData: action.payload || {},
      };
    default:
      return state;
  }
};
export default transactionHistory;



// WEBPACK FOOTER //
// ./reducer/transactionHistory/index.js